import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import utils from "@utils";
import { Image, Tooltip } from "../../../../components";

const ClientCard = ({
	onClickCard,
	data: {
		Id,
		Name,
		ClientLogo,
		PrimaryContactEmail,
		PrimaryContactPhoneNumber,
		TotalJobCount,
		TotalLocationCount,
		isRKPay,
		IsAgencyRKPayEnabled,
	},
}) => {
	const onClick = () => {
		onClickCard(Id);
	};

	return (
		<div className="card">
			<div
				className={classNames("flex margin-top-10", {
					"padding-bottom-19": !PrimaryContactPhoneNumber && !PrimaryContactEmail,
				})}
			>
				<If condition={PrimaryContactPhoneNumber}>
					<div className={classNames("flex-1 padding-left-15 text-left")}>
						<Tooltip content={utils.formatPhoneNumber(PrimaryContactPhoneNumber)}>
							<a href={`tel:${PrimaryContactPhoneNumber}`}>
								<i className="rkf rkf-phone color-blue-ebony-clay font-size-16" />
							</a>
						</Tooltip>
					</div>
				</If>
				<If condition={PrimaryContactEmail}>
					<div className={classNames("flex-1 padding-right-15 text-right")}>
						<Tooltip content={PrimaryContactEmail}>
							<a href={`mailto:${PrimaryContactEmail}`}>
								<i className="rkf rkf-email color-blue-ebony-clay font-size-16" />
							</a>
						</Tooltip>
					</div>
				</If>
			</div>
			<button
				type="button"
				tabIndex={0}
				className="flex-center flex-direction-column margin-top-20 client-card"
				onClick={onClick}
			>
				<Choose>
					<When condition={ClientLogo}>
						<Image
							src={ClientLogo}
							className="height-80 width-80 img-circle"
						/>
					</When>
					<Otherwise>
						<div className="no-client-image-list">
							<i className="rkf rkf-business" />
						</div>
					</Otherwise>
				</Choose>
				<p
					className={classNames(
						"color-blue-picton font-semi-bold font-size-16 padding-top-10",
						{ "margin-bottom-44": !(isRKPay || IsAgencyRKPayEnabled) },
					)}
				>
					{Name}
				</p>
				<If condition={isRKPay || IsAgencyRKPayEnabled}>
					<div className="margin-bottom-15">
						<Image
							src="/images/rkpayActive.png"
							className="margin-top--2"
						/>{" "}
						<span className="color-gray-ghost">RKPay Active</span>
					</div>
				</If>
			</button>
			<button
				type="button"
				tabIndex={-1}
				className="footer"
				onClick={onClick}
			>
				<div className="flex-1 text-center">
					<small className="font-size-12 font-light color-gray-ghost">Total Jobs</small>
					<h5 className="margin-top-0 margin-top-5 font-semi-bold font-size-16 color-blue-ebony-clay">
						{TotalJobCount}
					</h5>
				</div>
				<div className="separator-vertical" />
				<div className="flex-1 text-center">
					<small className="font-size-12 font-light color-gray-ghost">
						Total Locations
					</small>
					<h5 className="margin-top-0 margin-top-5 font-semi-bold font-size-16 color-blue-ebony-clay">
						{TotalLocationCount}
					</h5>
				</div>
			</button>
		</div>
	);
};

ClientCard.propTypes = {
	onClickCard: PropTypes.func.isRequired,
	data: PropTypes.object.isRequired,
};

export default ClientCard;
